
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire1936"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire1936"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("2Y9V7", function(module, exports) {

$parcel$export(module.exports, "persistLeadParamsFromLocation", function () { return $2298e1590f8efa74$export$955ab3e2d0257ee; });
$parcel$export(module.exports, "loadStoredLeadParams", function () { return $2298e1590f8efa74$export$379a388bc83c4d40; });
const $2298e1590f8efa74$var$STORAGE_PREFIX = 'lead_param_';
const $2298e1590f8efa74$export$aa1aa6c9f4607a8a = [
    'source',
    'sport',
    'package',
    'application_upload_date',
    'site',
    'site_form',
    'site_language',
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_term',
    'utm_content',
    'ad_id',
    'adset_id',
    'campaign_id'
];
function $2298e1590f8efa74$var$setSessionCookie(name, value) {
    document.cookie = `${name}=${encodeURIComponent(value)}; path=/`;
}
function $2298e1590f8efa74$var$getCookie(name) {
    const cookies = document.cookie.split('; ');
    for (const cookie of cookies){
        const [key, value] = cookie.split('=');
        if (key === name) return decodeURIComponent(value);
    }
    return null;
}
function $2298e1590f8efa74$export$955ab3e2d0257ee(search = window.location.search) {
    if (!search) return;
    const params = new URLSearchParams(search);
    $2298e1590f8efa74$export$aa1aa6c9f4607a8a.forEach((key)=>{
        const value = params.get(key);
        if (value !== null) $2298e1590f8efa74$var$setSessionCookie(`${$2298e1590f8efa74$var$STORAGE_PREFIX}${key}`, value);
    });
}
function $2298e1590f8efa74$var$readGaClientId() {
    const raw = $2298e1590f8efa74$var$getCookie('_ga');
    if (!raw) return null;
    const match = raw.match(/^GA1\.\d+\.(.+)$/);
    return match ? match[1] : null;
}
function $2298e1590f8efa74$var$readGaSessionId() {
    const cookies = document.cookie.split('; ');
    for (const cookie of cookies){
        const [name, value] = cookie.split('=');
        if (name && name.startsWith('_ga_') && name !== '_ga') {
            const decoded = decodeURIComponent(value || '');
            const match = decoded.match(/^GS1\.\d+\.(\d+)/);
            if (match) return match[1];
        }
    }
    return null;
}
function $2298e1590f8efa74$export$379a388bc83c4d40() {
    const result = {};
    $2298e1590f8efa74$export$aa1aa6c9f4607a8a.forEach((key)=>{
        const cookieValue = $2298e1590f8efa74$var$getCookie(`${$2298e1590f8efa74$var$STORAGE_PREFIX}${key}`);
        if (cookieValue !== null && cookieValue !== '') result[key] = cookieValue;
    });
    const gaClientId = $2298e1590f8efa74$var$readGaClientId();
    if (gaClientId) result.ga_client_id = gaClientId;
    const gaSessionId = $2298e1590f8efa74$var$readGaSessionId();
    if (gaSessionId) result.ga_session_id = gaSessionId;
    return result;
}

});

parcelRegister("klx5x", function(module, exports) {

$parcel$export(module.exports, "initMetaPixel", function () { return $ecff6f753fd64f61$export$a5d99109b1fe3046; });
$parcel$export(module.exports, "trackMeta", function () { return $ecff6f753fd64f61$export$2059e0c37ad421e5; });
function $ecff6f753fd64f61$var$shouldDisableMetaPixel() {
    if (typeof window === "undefined") return true;
    const { hostname: hostname, protocol: protocol } = window.location;
    return hostname === "localhost" || hostname === "127.0.0.1" || hostname === "::1" || protocol === "file:";
}
function $ecff6f753fd64f61$export$a5d99109b1fe3046({ pixelId: pixelId, trackPageView: trackPageView = true } = {}) {
    if (typeof window === "undefined") return;
    if (!pixelId) return;
    if ($ecff6f753fd64f61$var$shouldDisableMetaPixel()) return;
    if (window.fbq) {
        if (trackPageView) window.fbq("track", "PageView");
        return;
    }
    !function(f, b, e, v, n, t, s) {
        if (f.fbq) return;
        n = f.fbq = function() {
            n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = true;
        n.version = "2.0";
        n.queue = [];
        t = b.createElement(e);
        t.async = true;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s);
    }(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
    window.fbq("init", pixelId);
    if (trackPageView) window.fbq("track", "PageView");
}
function $ecff6f753fd64f61$export$2059e0c37ad421e5(eventName, params = {}) {
    try {
        if (typeof window === "undefined") return;
        if ($ecff6f753fd64f61$var$shouldDisableMetaPixel()) return;
        if (!window.fbq) return;
        window.fbq("track", eventName, params, {
            eventID: crypto.randomUUID()
        });
    } catch (_) {}
}

});


var $2Y9V7 = parcelRequire("2Y9V7");

var $klx5x = parcelRequire("klx5x");
(0, $2Y9V7.persistLeadParamsFromLocation)();
(0, $klx5x.initMetaPixel)({
    pixelId: "911922857908936",
    trackPageView: true
});


//# sourceMappingURL=en-run.97a2f82b.js.map
